// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `th.table-th-total_time, td.table-td-total_time {
  width: 16em;
}

.sparepart--qty input {
  flex: 0 0 auto;
  width: 50px;
}

.btn-upload ::ng-deep .p-button.p-fileupload-choose {
  padding: 5px;
}
.btn-upload ::ng-deep .p-button.p-fileupload-choose .p-button-icon {
  font-size: 0.7rem;
}
.btn-upload ::ng-deep .p-button.p-fileupload-choose .p-button-label {
  font-size: 0.7rem;
}

.folder-name {
  min-width: 8em;
}

.tableTimes td {
  padding-top: 20px;
  padding-right: 50px;
}

.tableTimes tr td:nth-child(2) {
  border-bottom: 1px #979797 solid;
}

.tableTimes {
  margin-top: 50px;
  margin-left: 50px;
}

.wo-details-section {
  border: 1px solid #979797;
  border-radius: 10px;
  overflow: scroll;
  height: 66vh;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
